import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import CDClogo from '../assets/CDC Full Logo.png';

const AboutSection = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, sm: 10, md: 15 },
        px: 3,
        background: 'linear-gradient(80deg, rgba(208, 220, 216, 0.85) 0%, rgba(240, 255, 250, 0.85) 100%)'
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: 0, md: 6 },
          }}
        >
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
            <Typography variant="h4" gutterBottom sx={{ fontStyle: 'italic' }}>
              Who I Am & Why I Do This
            </Typography>
            <Typography sx={{ mb: 2 }}>
              After a 35+ year corporate career leading marketing, partnerships, customer success, and growth across industries including fintech, payments, hospitality, travel, and media, I’ve transitioned what began as my passion project into my full-time work helping individuals navigate divorce. Today, I bring that same structured, strategic approach to helping clients navigate complex and high-conflict divorces.
            </Typography>
            <Typography sx={{ mb: 2 }}>
              The most defining chapter of my life began in 2019, when my nearly 24-year marriage ended in a high-conflict divorce. It was disorienting, like watching the world I had built collapse overnight, and it forced me to rebuild every part of my life.
            </Typography>
            <Typography sx={{ mb: 2 }}>
              That experience changed everything. It taught me that while divorce can make you feel powerless, regaining control is possible with the right structure, support, and mindset. I became a CDC Certified Divorce Coach® & Advisor to be the person I wish I had. Someone who understands not only the emotional chaos, legal maze, and financial uncertainty, but also the countless practical realities: how to prepare for court appearances, communicate effectively with your spouse, navigate co-parenting challenges, and make informed decisions about your settlement and your future.
            </Typography>
          </Box>

          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', mt: { xs: 0, md: 0 } }}>
            <Typography sx={{ mb: 2 }}>
              I draw on both my professional background and my certification training to guide clients with the same clarity, organization, and steady direction that defined my corporate career.
            </Typography>
            <Typography sx={{ mb: 2 }}>
              What began as a personal commitment has become my purpose: helping others move through divorce with control, confidence, and a clear plan forward. Using a structured, step-by-step approach I’ve developed called the Vision Tunnel Method™, I help clients stay grounded, manage what feels overwhelming, and rebuild their lives with strength and intention.
            </Typography>
            <Typography sx={{ mb: 2 }}>
              Because divorce doesn’t define you—it refines you. While you can’t always control what’s happening around you, you can control how you respond to it, and that’s where your power begins to return. My goal is to help you reclaim that power, make decisions that reflect what truly matters, and move forward with confidence toward the life you choose next.
            </Typography>
            <Box
              component="img"
              src={CDClogo}
              alt="Certified Divorce Coach"
              sx={{
                width: { xs: '300px', sm: '360px', md: '380px' },
                height: 'auto',
                mt: 3,
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.05)',
                },
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default AboutSection;
